<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/usuarios">Empresas</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhes Empresa</li>
        </ol> 


        <!-- Dados usuário-->
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Empresa COD: {{empresa.id}}
            </h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Criação</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.created_at"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.email"
                  @blur="(event) => empresa.login = event.target.value"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="empresa.nome"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Plano</label>
                <select
                class="form-control"
                v-model="empresa.plans_id"
                >
                  <option v-for="plan in planos" :key="plan.id" :value="plan.id">
                    {{ plan.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Quantidade de Funcionarios</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  readonly
                  v-model="empresa.qtd_funcionarios"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="empresa.telefone"
                />
              </div>
            </div>
<!--             <div class="col-md-3">
              <div class="form-group">
                <label>Provider ID</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="usuario.provider_id"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Permissão</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="usuario.role"
                />
              </div>
            </div> -->
            <!-- <div class="col-md-3">
              <router-link :to="`/adm/assinantes/${subscription.protocolo}`">Detalhes da assinatura</router-link>
            </div> -->
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="salvaInfoEmpresa()">Salvar</button>
                <button class="btn_1 red delete wishlist_close mt-1 mb-1 button-content" @click="desativaempresa(props.item)">
                  <i class="fa fa-times mr-2"></i> Desativar
                </button>
              </p>
            </div>
          </div>
        </div>

        <!-- Dados Subscriber-->
        <!-- <div class="box_general padding_bottom" v-if="subscriber.id">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Subscriber COD: {{subscriber.id}}
            </h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>Aniversário</label>
                <input
                  type="birth"
                  class="form-control"
                  placeholder="DD/MM/AAAA"
                  v-mask="['##/##/####']"
                  v-model="formattedBirthDate"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CPF</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.cpf"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>RG</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.rg"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.zip_code"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Estado</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.state"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.city"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Rua</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.street"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.district"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Número</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder
                  v-model="subscriber.street_number"
                />
              </div>
            </div>
            <template v-if="phone">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Área</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder
                    v-model="phone.area_code"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Número de telefone</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder
                    v-model="phone.number"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Complemento</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder
                    v-model="subscriber.complement"
                  />
                </div>
              </div>
            </template>
          </div>

          <div class="row">
            <div class="col-md-12">
              <p>
                <button href="#0" class="btn_1 medium pull-right" @click="salvaInfoSubscriber()">Salvar</button>
              </p>
            </div>
          </div>
        </div> -->

        <!-- Dados Participantes-->
<!--         <template v-if="dependentes.length > 0">
          <div class="box_general padding_bottom" :key="dependente.dependente_id" v-for="dependente of dependentes">
            <div class="header_box version_2">
              <h2>
                <i class="fa fa-info-circle"></i>Informações do Participante COD: {{dependente.id}}
              </h2>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Nome</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.nome_dependente"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Aniversário</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.birth_date"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>RG</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.rg"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>CPF</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="['###.###.###-##']"
                    v-model="dependente.cpf"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Nome da Mãe</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.nome_mae"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Plano</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.name"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Parentesco</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.parentesco"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>CNS</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="dependente.cns"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <p>
                  <button href="#0" class="btn_1 medium pull-right" @click="salvaInfoDependente(dependente)">Salvar</button>
                </p>
              </div>
            </div>
          </div>
        </template> -->
      </div>
    </div>
  </div>
      <!-- /container-fluid-->
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import { ReturnStringErrorByArrayOfErrors } from '../../../utils/util';
import { cnpj } from "cpf-cnpj-validator";

export default {
  components: {
    VueEditor,
    Money
  },
  mixins: [funcoesGerais],
  data() {
    return {
      id_empresa: this.$route.params.id_empresa,
      empresa: {},
      subscriber: {},
      phone: {},
      dependentes: [],
      isLoading: false,
      aprovacao: false,
      subscription: {},
      planos:{},
    };
  },
  computed: {
    formattedBirthDate: {
      get() {
        if (this.subscriber.birth_date) {
          const [year, month, day] = this.subscriber.birth_date.split('-');
          return `${day}/${month}/${year}`;
        }
        return '';
      },
      set(newValue) {
        const [day, month, year] = newValue.split('/');
        this.subscriber.birth_date = `${year}-${month}-${day}`;
      }
    }
  },
  mounted() { 
    let self = this;
    self.isLoading = true;
    ajax(
      "get",
      "empresas/" + self.id_empresa
    )
      .then(response => {
        self.isLoading = false;
        self.empresa = response ? response : {};
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error, this);
      });
    ajax(
      "get",
      "planos"
    )
    .then(res=>{
      this.planos=res
    })
  },
  methods: {
    desativaempresa(empresa){
           let self = this;
           self.isLoading = true;
         ajax("delete", "empresas/" + empresa.id)
           .then(response => {
             let indexItemRemovido = self.empresa.findIndex(
               x => x.id == empresa.id
             );
             self.empresa[indexItemRemovido].deleted_at = 1;
             self.isLoading = false;
             alerta(
               "success",
               "Desativado",
               "Empresa desativado com sucesso!"
             );
           })
           .catch(error => {
             self.isLoading = false;
             tratamento_requisicao(error, this);
           });
      },
    salvaInfoEmpresa() {
      let self = this;
      const cnpjValid=cnpj.isValid(self.empresa.cnpj)
      if (self.empresa.email && self.empresa.nome && cnpjValid) {
        self.isLoading = true;
        ajax("put", `empresas/${self.empresa.id}`, self.empresa)
        .then(() => {
          self.isLoading = false;
          alerta("success", "Sucesso", "Dados atualizados com sucesso!")
        }).catch(e => {
          self.isLoading = false;
          tratamento_requisicao(e)
        })
      } else {
        let erros = {};
        if (!self.empresa.nome) erros.name = ["O campo nome é obrigatório."];
        if (!self.empresa.email) erros.email = ["O campo email é obrigatório."];
        if (!cnpjValid) erros.cnpj = ["CNPJ invalido"];
        alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
      }
    },

    salvaInfoSubscriber(){
      let self = this;
      let objeto = {
        "subscriber": self.subscriber,
        "phones": self.phone
      }
      if(objeto.subscriber.birth_date && objeto.subscriber.city&&objeto.subscriber.district&&objeto.subscriber.street&&objeto.subscriber.cpf&&objeto.phones.area_code&&objeto.phones.number&&objeto.subscriber.zip_code&&objeto.subscriber.street_number){
        self.isLoading = true;
        ajax("put", `usuarios/${self.usuario.id}`, objeto)
      .then(() => {
        self.isLoading = false;
        alerta("success", "Sucesso", "Dados alterados com sucesso!");
      }).catch(e => {
        self.isLoading = false;
        tratamento_requisicao(e);
      })} else {
        let erros = {};
        if (!objeto.subscriber.birth_date) erros.birth_date = ["O campo Aniversário é obrigatório."];
        if (!objeto.subscriber.city) erros.city = ["O campo cidade é obrigatório."];
        if (!objeto.subscriber.district) erros.bairro = ["O campo bairro é obrigatório."];
        if (!objeto.subscriber.street) erros.street = ["O campo Rua é obrigatório."];
        if (!objeto.subscriber.cpf) erros.cpf = ["O campo CPF é obrigatório."];
        if (!objeto.phones.area_code) erros.area_code = ["O campo Área é obrigatório."];
        if (!objeto.phones.number) erros.phone_number = ["O campo Número de telefone é obrigatório."];
        if (!objeto.subscriber.zip_code) erros.zip_code = ["O campo CEP é obrigatório."];
        if (!objeto.subscriber.street_number) erros.street_number = ["O campo Número é obrigatório."];
        alerta("warning", "Atenção", ReturnStringErrorByArrayOfErrors(erros));
      }
    },

    salvaInfoDependente(dependente) {
      let self = this;
      self.isLoading = true;

      let objeto = {
        "name": dependente.nome_dependente,
        "birth_date": dependente.birth_date,
        "rg": dependente.rg,
        "cpf": dependente.cpf,
        "nome_mae": dependente.nome_mae,
        "parentesco": dependente.parentesco,
        "cns": dependente.cns
      }


      ajax("put", `dependentes/${dependente.dependente_id}`, objeto)
      .then(() => {
        self.isLoading = false;
        alerta("success", "Sucesso", "Participante editado com sucesso!");
      }).catch(e => {
        self.isLoading = false;
        tratamento_requisicao(e);
      })


    },

    salvaTrava(trava) {
      let self = this;
      self.isLoading = true;
      ajax("put", "travas/" + trava.id, trava)
          .then(response => {
            self.isLoading = false;
            if(trava.bicicletarios_id == self.id_bicicletario) {
              let index = self.travas_restantes.indexOf(trava)
              if(index > -1){
                self.travas_restantes.splice(index, 1)
                self.travas_vinculadas.push(trava);
              }
            }
            alerta(
              "success",
              "Atualizada",
              "Trava atualizada com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });   
      },
      criarTrava() {
      let self = this;
      self.isLoading = true;
        ajax("post", "travas", self.nova_trava)
        .then(response => {
          self.isLoading = false;
          self.travas.push(response);
          self.travas_vinculadas.push(response);
          self.nova_trava = {};
          self.nova_trava.bicicletarios_id = self.id_bicicletario;
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
      },
      deletaTrava(trava) {
        let self = this;
        self.isLoading = true;
         ajax("delete", "travas/" + trava.id)
           .then(response => {

             self.isLoading = false;
             //Remover do array travas....
             for (let aux in self.travas) {
              if(self.travas[aux].id == trava.id) {
                  self.travas.splice(aux, 1);
                }
             }

             //Verificar se está em restantes, se tiver remover, senão, remover dos vinculados
            let index = self.travas_restantes.indexOf(trava);
            if(index > -1){
                self.travas_restantes.splice(index, 1)
            } else {
              self.travas_vinculadas.splice(self.travas_vinculadas.indexOf(trava), 1);
            }
              
             alerta(
               "success",
               "Desativada",
               "Coordenada desativada com sucesso!"
             );
           })
           .catch(error => {
             self.isLoading = false;
             tratamento_requisicao(error, this);
           });
      }
  },

};
</script>

<style scoped>
.input-horario {
  width: 50px;
  border: blue;
}

.header_box span i{
  color: #ffd700;
  font-size: 20px;
}
</style>